import { createContext } from "react";
import { View } from "views/View";

export interface TaskViewsContextProps {
  views: View[];
  selectedView: View;
  setSelectedViewName: (name: string) => void;
}

export const TaskViewsContext = createContext({} as TaskViewsContextProps);
